import Vue from 'vue'
import VueComposition from '@vue/composition-api'

Vue.use(VueComposition)
